module.exports = __webpack_public_path__ + "img/home-07-cosmo-popup-bg-03.18afa2ef.jpg";